<template>
  <tr>
  	<td>{{ item.code }}</td>
    <td class="text-xs-right">{{ item.total | roundValue }}</td>
    <td>{{ item.customer_name }} </td>
    <td>{{ item.agent_name }} <br>
      <span v-if="item.agent && item.agent_commission_percent">{{ item.agent_commission_amount | roundValue }} ({{ item.agent_commission_percent || 0 }}%)</span>
    </td>
    <td>{{ item.retailer_name }} <br>
      <span class="text-xs-right" v-if="item.retailer && item.retailer_commission_percent">{{ item.retailer_commission_amount | roundValue }} ({{ item.retailer_commission_percent || 0 }}%)</span>
    </td>
    <td>{{ item.executive_name }} <br>
      <span v-if="item.executive && item.executive_commission_percent">{{ item.executive_commission_amount | roundValue }} ({{ item.executive_commission_percent || 0 }}%)</span>
    </td>
    <td class="align-center justify-center layout px-0">
      <v-icon small class="mr-1" v-if="isPending || isAdded" @click="$emit('edit', item)" title="Update Commission">edit</v-icon>
      <v-icon small class="mr-1" v-if="isAdded" @click="$emit('confirm', item)" title="Approve Commission">done</v-icon>
      <router-link href="_new" :to="`/proforma-invoice/${item.code}/view`" title="View Proforma Invoice">
        <v-icon small class="mr-1">visibility</v-icon>
      </router-link>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'CommissionListItem' ,
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.commission_status == this.config.commissionStatus.pending
    },

    isAdded () {
      return this.item.commission_status == this.config.commissionStatus.added
    },

    isApproved () {
      return this.item.commission_status == this.config.commissionStatus.approved
    },

    isCancelled () {
      return this.item.commission_status == this.config.commissionStatus.cancelled
    }

  },

  watch: {
    
  }
}
</script>